module.exports = __webpack_public_path__ + "static/media/coins.0ba538a9.svg";